module.exports = __webpack_public_path__ + "static/img/CgoRDGORiLyAbUeKAAx3NAkSU0E738.2bf323a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORiLyAbUeKAAx3NAkSU0E738.png
// module id = Ofj3
// module chunks = 73